export function GuideDev() {
    return (
        <div>new guide page</div>
    )
}